;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.closeNav = (function () {
    const initialize = function () {
      $('.js-closeNav').on('click', function (e) {
        e.preventDefault()
        $(this).parents('nav').removeClass('spmenu-open')
        $('body').removeClass('spmenu-push spmenu-push-toleft spmenu-push-toright')
      })
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.closeNav.initialize()
  })
}(jQuery, window))
